import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { DropdownButton } from "@similarweb/ui-components";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import { translate } from "app/filters/i18nFilter";
import { FormSelect } from "app/pages/sales-intelligence/common-components/form-fields";
import { useCompanyName } from "app/pages/sales-intelligence/modules/ai-agent/hooks/useCompanyName";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { TextField } from "app/pages/sales-intelligence/pages/ai-agent/components/TextfField/TextField";
import type { FirstRespondFormValues } from "app/pages/sales-intelligence/pages/ai-agent/hooks/useFirstRespondForm";

export const MEETING_GOAL_OTHER_OPTION = "Other (please specify)";
export const meetingGoalOptions = [
    "Intro",
    "Follow up",
    "Renewal",
    "QBR",
    "Upsell/Expansion",
    "Close deal",
    MEETING_GOAL_OTHER_OPTION,
];

type Props = {
    valueOption: string | undefined;
    value: string | undefined;
    onChange: (key: keyof FirstRespondFormValues, value: string | undefined) => void;
    disabled: boolean;
};

export const MeetingGoal: React.FC<Props> = ({ valueOption, onChange, disabled, value }) => {
    const companyName = useCompanyName();

    const handleSelect = (option: string) => {
        onChange("meetingGoalOption", option);
        if (option !== MEETING_GOAL_OTHER_OPTION) {
            onChange("meetingGoal", option);
        } else {
            onChange("meetingGoal", undefined);
        }

        AIAgentTrackingService.meeting.trackSelectMeetingGoal(companyName, option);
    };

    const handleChange = (value: string) => {
        onChange("meetingGoal", value);
    };

    const renderDropdownButton = () => {
        return (
            <StyledBaseDropdownButtonWrap
                buttonTextColor={
                    disabled
                        ? colorsPalettes.midnight[100]
                        : valueOption
                          ? colorsPalettes.carbon[400]
                          : colorsPalettes.carbon[200]
                }
                disabled={disabled}
            >
                <DropdownButton disabled={disabled}>
                    {valueOption ?? translate("si.pages.ai_agent.form.goal.dd.placeholder")}
                </DropdownButton>
            </StyledBaseDropdownButtonWrap>
        );
    };

    return (
        <>
            <FormSelect
                options={meetingGoalOptions}
                onChange={handleSelect}
                fieldName="meetingGoalOption"
                width={320}
                placeholder={translate("si.pages.ai_agent.form.goal.dd.placeholder")}
                dropdownPopupPlacement="bottom-left"
                value={valueOption}
                disabled={disabled}
                dropdownPopupHeight={308}
                renderButton={renderDropdownButton}
                {...(disabled ? { dropdownWrapperStyled: { cursor: "not-allowed" } } : {})}
            />
            {valueOption === MEETING_GOAL_OTHER_OPTION ? (
                <TextField
                    placeholder={translate("si.pages.ai_agent.form.goal.textfield.placeholder")}
                    onChange={handleChange}
                    disabled={disabled}
                    margin="8px 0 0"
                    defaultValue={value}
                    autoFocus={true}
                    width={320}
                />
            ) : null}
        </>
    );
};
